import './translations_editing_disabled_div.less';

import React from 'react';
import PropTypes from 'prop-types';

import Tipsy from 'zoomforth_component_lib/tipsy.jsx';


const TranslationsEditingDisabledDiv = ({ isDisabled, children, style, maskStyle })=> {
  if (!isDisabled) {
    return children;
  }

  return (
    <Tipsy content="This feature is disabled while editing a secondary language">
      <div className="translations-editing-disabled-wrapper" style={style}>
        <div className="editing-disabled-mask" style={maskStyle} />
        { children }
      </div>
    </Tipsy>
  );
};

TranslationsEditingDisabledDiv.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
  styles: PropTypes.object
};

export default TranslationsEditingDisabledDiv;
